import get from 'lodash/get';
export const _get = get;
